/**
 * @param {String[]} userRoles
 * @param {String[]} [excludedRoles]
 *
 * @return {Boolean}
 */
export default function canAccess(userRoles, excludedRoles = []) {
  return userRoles.filter(role => !excludedRoles.includes(role)).length > 0;
}
